import { HiDotsHorizontal } from "react-icons/hi";
import { hyundai, notJoined } from "../../assets/images";
import React, { useState } from "react";
import { CommunityProps } from "../../types";
import { AiOutlinePlus } from "react-icons/ai";
import { useSelector } from "react-redux";
import SkeletonSugestedCom from "../skeletons/skeletonSugestedCom";
import { SkeletonElement } from "..";
import { ipfsGatewayImage } from "../../utils/ipfsGatewayImage";
import { useNavigate } from "react-router-dom";
import "react-tooltip/dist/react-tooltip.css";
import { Tooltip } from "react-tooltip";

type LeftSideBarProps = {
  community?: CommunityProps | null;
  userIsAMember: CommunityProps[] | undefined;
  loading: boolean;
  setOpenCreate: React.Dispatch<React.SetStateAction<boolean>>;
  toggle: boolean | (() => void);
};
const LeftSideBar: React.FC<LeftSideBarProps> = ({
  userIsAMember,
  loading,
  setOpenCreate,
  toggle,
}) => {
  const [active, setActive] = useState<number | null>(null);

  const user = useSelector((state: any) => state.user.userDetails);

  const handleActive = (index: number) => {
    setActive(index);
  };
  const notAMember = userIsAMember?.filter((mems: CommunityProps) =>
    mems.members.some((mem) => mem.id === user?.id)
  );

  const navigate = useNavigate();

  // useEffect(() => {
  //   if (isRefetching) {
  //     isRefetching();
  //   }
  //   return () => {};
  // }, [isRefetching]);

  const handleOpen = () => {
    if (setOpenCreate) setOpenCreate(true);
    if (typeof toggle === "function") {
      toggle();
    }
  };

  if (loading) {
    return (
      <div className="w-full lg:flex flex-col hidden  sticky top-24 bg-white h-[300px] px-2 py-3">
        <div className="mb-3 ml-1 w-full">
          <SkeletonElement type="title" />
        </div>
        {[1, 2, 3, 4, 5].map((n) => (
          <SkeletonSugestedCom key={n} />
        ))}
      </div>
    );
  }

  return (
    <div className="lg:flex hidden sticky top-24 flex-col bg-white rounded w-full p-3 shadow">
      {notAMember?.length === 0 ? (
        <img src={notJoined} alt="" />
      ) : (
        <>
          <div className="w-full items-center flex justify-between mb-3">
            <h4 className="font-Poppins text-[9.3px] font-medium text-lightGreyText">
              COMMUNITY YOU'VE JOINED
            </h4>
            <div
              className="w-5 h-5 p-1 flex rounded-full cursor-pointer bg-[rgba(33,87,89,0.05)]"
              onClick={handleOpen}
              data-tooltip-id="my-tooltip"
              data-tooltip-content="Create a community"
              data-tooltip-place="top-end"
            >
              <AiOutlinePlus size={12} className="fill-midGreen" />
            </div>
          </div>

          <div className="grid gap-3 items-center rounded-sm">
            {userIsAMember?.map((com, index) => {
              const header: { href: string; name: string } = {
                href: `/ecobook/community/${com.name}/${com.id}`,
                name: com.name,
              };

              return (
                <div
                  className={`flex items-center justify-between pt-1 cursor-pointer ${
                    active === index ? "bg-midGreen h-9 ease-linear" : ""
                  }`}
                  onClick={() => {
                    handleActive(index);
                    navigate(header.href);
                  }}
                  key={index}
                >
                  <div className="flex gap-3 items-center justify-center">
                    <img
                      alt=""
                      src={
                        com.communityHeaderImgUrl
                          ? ipfsGatewayImage(com.communityHeaderImgUrl)
                          : hyundai
                      }
                      className={`w-7 h-7 rounded-full ${
                        active === index ? "ml-1 mb-1" : ""
                      }`}
                    />
                    <h4
                      className={`font-Poppins text-[12.07px] font-semibold ${
                        active === index ? "text-white" : "text-lightBlack"
                      }`}
                    >
                      {header.name}
                    </h4>
                  </div>
                  <HiDotsHorizontal
                    size={13}
                    className={`${
                      active === index ? "fill-white" : "fill-lightGreyText"
                    } `}
                  />
                </div>
              );
            })}
          </div>
          <Tooltip id="my-tooltip" />
        </>
      )}
    </div>
  );
};

export default LeftSideBar;
